module.exports = __webpack_public_path__ + "img/feature_2.78ff8671.png";